!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.vi = t()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'vi',
      pluralRuleFunction: function (e, t) {
        return t && 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'Năm',
          relative: { 0: 'năm nay', 1: 'năm sau', '-1': 'năm ngoái' },
          relativeTime: { future: { other: 'sau {0} năm nữa' }, past: { other: '{0} năm trước' } }
        },
        'year-short': {
          displayName: 'Năm',
          relative: { 0: 'năm nay', 1: 'năm sau', '-1': 'năm ngoái' },
          relativeTime: { future: { other: 'sau {0} năm nữa' }, past: { other: '{0} năm trước' } }
        },
        month: {
          displayName: 'Tháng',
          relative: { 0: 'tháng này', 1: 'tháng sau', '-1': 'tháng trước' },
          relativeTime: { future: { other: 'sau {0} tháng nữa' }, past: { other: '{0} tháng trước' } }
        },
        'month-short': {
          displayName: 'Tháng',
          relative: { 0: 'tháng này', 1: 'tháng sau', '-1': 'tháng trước' },
          relativeTime: { future: { other: 'sau {0} tháng nữa' }, past: { other: '{0} tháng trước' } }
        },
        day: {
          displayName: 'Ngày',
          relative: { 0: 'Hôm nay', 1: 'Ngày mai', 2: 'Ngày kia', '-2': 'Hôm kia', '-1': 'Hôm qua' },
          relativeTime: { future: { other: 'sau {0} ngày nữa' }, past: { other: '{0} ngày trước' } }
        },
        'day-short': {
          displayName: 'Ngày',
          relative: { 0: 'Hôm nay', 1: 'Ngày mai', 2: 'Ngày kia', '-2': 'Hôm kia', '-1': 'Hôm qua' },
          relativeTime: { future: { other: 'sau {0} ngày nữa' }, past: { other: '{0} ngày trước' } }
        },
        hour: {
          displayName: 'Giờ',
          relative: { 0: 'giờ này' },
          relativeTime: { future: { other: 'sau {0} giờ nữa' }, past: { other: '{0} giờ trước' } }
        },
        'hour-short': {
          displayName: 'Giờ',
          relative: { 0: 'giờ này' },
          relativeTime: { future: { other: 'sau {0} giờ nữa' }, past: { other: '{0} giờ trước' } }
        },
        minute: {
          displayName: 'Phút',
          relative: { 0: 'phút này' },
          relativeTime: { future: { other: 'sau {0} phút nữa' }, past: { other: '{0} phút trước' } }
        },
        'minute-short': {
          displayName: 'Phút',
          relative: { 0: 'phút này' },
          relativeTime: { future: { other: 'sau {0} phút nữa' }, past: { other: '{0} phút trước' } }
        },
        second: {
          displayName: 'Giây',
          relative: { 0: 'bây giờ' },
          relativeTime: { future: { other: 'sau {0} giây nữa' }, past: { other: '{0} giây trước' } }
        },
        'second-short': {
          displayName: 'Giây',
          relative: { 0: 'bây giờ' },
          relativeTime: { future: { other: 'sau {0} giây nữa' }, past: { other: '{0} giây trước' } }
        }
      }
    }
  ];
});
